/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum gap (seconds)" |
*
* @param {Ad_Template_Min_Gap_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_label = /** @type {((inputs?: Ad_Template_Min_Gap_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart minimal (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestlücke (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo minimo (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальный интервал (секунды)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hueco mínimo (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小间隔（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小ギャップ（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम अंतराल (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo mínimo (segundos)")
	return /** @type {LocalizedString} */ ("Minimum gap (seconds)")
});